<template>
  <section
    class="a-product-grid__container spacer-b js-track"
    v-bind:class="loadingClass"
    itemscope=""
    itemtype="http://schema.org/ItemList"
    data-ga-event-action="click"
    data-ga-event-category="product-list">
    <link itemprop="url" :href="pageUrl">
    <span itemprop="numberOfItems" class="sr-only">{{ countAll }}</span>
    <header class="text-center">
      <h2 v-if="!searchMode" class="title a-page-title color-grey hidden-xs hidden-sm a-product-grid__title spacer-b">{{currentGender}}</h2>
      <h2 v-if="searchMode" class="title a-page-title color-grey hidden-xs hidden-sm a-product-grid__title spacer-b">“&nbsp;{{searchQuery}}&nbsp;”</h2>
      <h2 class="title a-page-subtitle color-grey notice notice--inline notice--warning spacer-b" v-if="noResults">
        {{ copyNoResults }}
      </h2>
    </header>
    <div class="a-product-grid" :class="{'a-product-grid--flex': countAll <= 5}">
      <template v-for="p in products">
        <template v-if="p.siblingList">
          <product-highlight
            v-for="s in p.siblingList"
            :key="s.entryId"
            :url="s.url"
            :name="p.p_name"
            :sku="p.ref + '__' + s.color"
            :gender_plus="p.p_gender_plus"
            :entry_id="p.entry_id"
            :description="p.p_description"
            :price="s.p_price"
            :old_price="s.p_old_price"
            :title="p.title"
            :status="s.status"></product-highlight>
        </template>
        <template v-else>
          <product-highlight
            :key="p.entry_id"
            :url="p.p_url"
            :name="p.p_name"
            :sku="p.p_color_reference"
            :gender_plus="p.p_gender_plus"
            :entry_id="p.entry_id"
            :description="p.p_description"
            :price="p.p_price"
            :old_price="p.p_old_price"
            :title="p.title"
            :status="p.status"></product-highlight>
        </template>
      </template>
    </div>
  </section>
</template>

<script>
  import productHighlight from '@/components/ProductHighlight'

  export default {
    components: {
      productHighlight
    },
    computed: {
      products: function () {
        return this.$store.getters.getAllProducts
      },
      loadingClass: function () {
        return this.$store.getters.isLoading ? 'is-loading' : ''
      },
      countAll: function () {
        return this.$store.getters.productCount
      },
      pageUrl: function () {
        return this.$store.getters.getUrl
      },
      noResults: function () {
        return this.countAll === 0
      },
      copyNoResults: function () {
        return this.$store.getters.copy('no_results')
      },
      copyDiscover: function () {
        return this.$store.getters.copy('discover')
      },
      copyAvailableColors: function () {
        return this.$store.getters.copy('available_colors')
      },
      season: function () {
        return this.$store.getters.seasonURI
      },
      currentGender: function () {
        return this.$store.getters.copy(this.$store.getters.currentGender)
      },
      searchMode: function () {
        return this.$store.getters.searchMode
      },
      searchQuery: function () {
        return this.$store.getters.searchQuery
      }
    },
    methods: {
      isHighlight: function (entry) {
        return entry.status === 'highlight'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue